import { CampaignLimitType, ILimit } from '@/api/types'

const computedForCampaignLimits =
  (type: CampaignLimitType, props: any) => () => {
    const result = (props.modelValue as Array<ILimit>).find(
      (el) => el.type_id === type
    )
    if (result === undefined) {
      return { type_id: type, value: undefined }
    }
    return result
  }

const defineUpdateCampaignLimits =
  (props: any, context: any) => (newVal: ILimit) => {
    if (newVal.value === undefined) {
      return
    }
    const updatedLimits = JSON.parse(
      JSON.stringify(props.modelValue)
    ) as Array<ILimit>
    const index = updatedLimits.findIndex(
      (limit) => limit.type_id === newVal.type_id
    )
    if (index === -1) {
      updatedLimits.push(newVal)
    } else {
      updatedLimits[index] = newVal
    }
    context.emit('update:modelValue', updatedLimits)
  }

const defineRemoveCampaignLimits =
  (props: any, context: any) => (typeId: CampaignLimitType) => {
    const updatedLimits = JSON.parse(
      JSON.stringify(props.modelValue)
    ) as Array<ILimit>
    const index = updatedLimits.findIndex((limit) => limit.type_id === typeId)
    if (index !== -1) {
      updatedLimits.splice(index, 1)
    }
    context.emit('update:modelValue', updatedLimits)
  }

export {
  computedForCampaignLimits,
  defineUpdateCampaignLimits,
  defineRemoveCampaignLimits
}
